'use client'

import { useEffect } from 'react'
import {
    trackSessionReplayPageViewed,
    type SessionReplayPageViewedEvent,
} from '@/lib/analytics/sessionReplayPageViewedAnalytics'

interface SessionReplayPageViewedTrackerProps {
    event: SessionReplayPageViewedEvent
    properties?: Record<string, unknown>
}

/** Fires a page-viewed event that Nile-Core maps to a session replay Slack channel.
 *  Idempotency lives in trackSessionReplayPageViewed, keyed by page_view_id. */
export default function SessionReplayPageViewedTracker({
    event,
    properties,
}: SessionReplayPageViewedTrackerProps) {
    useEffect(() => {
        trackSessionReplayPageViewed(event, properties)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event])

    return null
}
